import { Link } from "react-router-dom";
import { Compass, ArrowLeft, Lock, Calculator, Cookie, Mail } from "lucide-react";

const SECTIONS = [
  {
    icon: Lock,
    title: "AI-rådgiveren",
    text: "Spørsmål og svar i AI-rådgiveren lagres kun i din egen nettleser, slik at du kan fortsette samtalen der du slapp. Ingen del av samtalen lagres på våre servere. Teksten sendes til OpenAI for å lage svaret. Ikke del personnummer, kontonummer eller andre sensitive opplysninger i chatten.",
  },
  {
    icon: Calculator,
    title: "Budsjett- og gjeldsverktøyet",
    text: "Tallene du skriver inn i budsjettkalkulatoren og gjeldsoversikten forblir i din egen nettleser. De sendes aldri til noen server og forsvinner når du lukker siden.",
  },
  {
    icon: Cookie,
    title: "Informasjonskapsler og statistikk",
    text: "Siden bruker kun en nødvendig påloggings-cookie for admin-siden. Plattformen siden kjører på (Emergent) samler anonym bruksstatistikk for drift og forbedring.",
  },
];

export default function Privacy() {
  return (
    <div className="min-h-screen bg-background text-foreground antialiased">
      <header className="border-b border-border/60 bg-background/80 backdrop-blur-md">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-16 flex items-center">
          <Link to="/" data-testid="privacy-back-link" className="flex items-center gap-2.5 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
            <span className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center">
              <Compass size={16} />
            </span>
            <span className="font-serif font-bold text-lg text-foreground">Gjeldsveiviseren</span>
            <span className="inline-flex items-center gap-1 text-xs"><ArrowLeft size={12} /> Til forsiden</span>
          </Link>
        </div>
      </header>

      <main data-testid="privacy-section" className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
        <p className="text-xs uppercase tracking-[0.2em] font-mono font-semibold text-terracotta">Personvern</p>
        <h1 className="mt-3 font-serif font-bold tracking-tight text-3xl sm:text-4xl text-primary">Personvernerklæring</h1>
        <p className="mt-4 text-muted-foreground leading-relaxed">
          Gjeldsveiviseren er en uavhengig, privat drevet opplysningsportal — ikke tilknyttet NAV eller
          andre offentlige etater. Vi samler inn så lite som mulig, og du kan bruke det meste av
          siden helt anonymt. Sist oppdatert: september 2026.
        </p>

        <div className="mt-10 space-y-5">
          {SECTIONS.map((s) => (
            <section key={s.title} className="bg-surface border border-border rounded-2xl p-6">
              <h2 className="flex items-center gap-2.5 font-semibold text-base">
                <s.icon size={17} className="text-primary" /> {s.title}
              </h2>
              <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{s.text}</p>
            </section>
          ))}
        </div>

        <section className="mt-10 bg-accent/60 border border-border rounded-2xl p-6">
          <h2 className="flex items-center gap-2.5 font-semibold text-base">
            <Mail size={17} className="text-primary" /> Dine rettigheter
          </h2>
          <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
            Etter personopplysningsloven (GDPR) har du rett til innsyn i, retting av og sletting av
            opplysninger om deg. Kontakt oss på{" "}
            <a href="mailto:henry.thrane@pm.me" data-testid="privacy-contact-email" className="font-semibold text-primary hover:underline">
              henry.thrane@pm.me
            </a>{" "}
            dersom du vil vite hva som er lagret, eller ønsker at noe skal slettes.
          </p>
        </section>
      </main>
    </div>
  );
}
